import { AvailableReturnItemReason } from "@narvar/nth-kit-returns-headless";

const displayReasons = ({
  reasons,
  selection,
}: {
  reasons: AvailableReturnItemReason[];
  selection: AvailableReturnItemReason[];
}): AvailableReturnItemReason[] => {
  const childNodes: AvailableReturnItemReason[] = reasons.reduce(
    (acc: AvailableReturnItemReason[], cur: AvailableReturnItemReason) =>
      cur.childIds && cur.childIds.length > 0
        ? ([
            ...acc,
            ...cur.childIds.map((id) =>
              reasons.find((reason) => id === reason.id),
            ),
          ] as AvailableReturnItemReason[])
        : acc,
    [],
  );

  const rootNodes: AvailableReturnItemReason[] = reasons.filter((reason) =>
    reason.id ? !childNodes.map(({ id }) => id).includes(reason.id) : true,
  );

  if (selection.length === 0) return rootNodes;

  const currentSelection = selection[selection.length - 1].id
    ? reasons.find((reason) => reason.id === selection[selection.length - 1].id)
    : reasons.find(
        (reason) => reason.name === selection[selection.length - 1].name,
      );

  if (
    (currentSelection && !currentSelection.childIds) ||
    currentSelection?.childIds?.length === 0
  ) {
    return [currentSelection];
  }

  return currentSelection?.childIds
    ?.map((childId) => childNodes.find(({ id }) => id === childId))
    .filter(Boolean) as AvailableReturnItemReason[];
};

export default displayReasons;
